export default __webpack_public_path__ + "static/media/hammer-logo.007a5a0a.png";